module.exports = __webpack_public_path__ + "static/img/wisf.c2e3ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wisf.png
// module id = TRPH
// module chunks = 1